/**
 * Global (not per-contractor) persistence for the shared project-details
 * survey. Per the PRD, the same survey/answers are used from the homepage,
 * the contractor listing, and the get-in-touch flow — one homeowner, one set
 * of answers, no auth to scope it any tighter than "this browser."
 */

import { getSurveyQuestionFlow } from "@/components/survey/_constants/surveyQuestions";

const STORAGE_KEY = "fevicolInhomzSurveyAnswers";

export function getSurveyAnswers() {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return {};
    }
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (error) {
    console.error("Error reading survey answers from localStorage:", error);
    return {};
  }
}

export function saveSurveyAnswers(answers) {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(answers || {}));
    return true;
  } catch (error) {
    console.error("Error saving survey answers to localStorage:", error);
    return false;
  }
}

export function isSurveyCompleted(answers) {
  if (!answers) {
    return false;
  }

  // Derived from the question flow so only the size question that applies to
  // the current property type counts (a stale `bhk` after switching to
  // commercial must not satisfy it).
  return getSurveyQuestionFlow(answers).every((q) => q.optional || Boolean(answers[q.id]));
}

export function clearSurveyAnswers() {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error("Error clearing survey answers from localStorage:", error);
    return false;
  }
}
